import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import users from "./user";
import company from "./company";
import agencies from "./agency"
import airports from "./airport";
import centers from "./center";
import bankaccounts from "./bankaccount";
import bookings from "./bookings";
import extras from "./extra";
import booking from "./booking";

export default combineReducers({
  auth,
  message,
  users,
  company,
  agencies,
  airports,
  centers,
  bankaccounts,
  bookings,
  booking,
  extras
});